import React, { useMemo, useRef, useEffect } from 'react'
import { Tree, TreeNode } from 'react-organizational-chart'
import Banners from '../../../GlobalComponents/User/Banners'

// Function to transform orderTreeData into the format for the organizational chart
const transformDataForTree = (data) => {
	return data.map((user) => ({
		id: user?.registerId,
		name: user?.fullName,
		level: user?.level || 0,
		children: user.users && user.users.length > 0 ? transformDataForTree(user.users) : [],
		gender: user?.gender, // Gender for image selection
	}))
}

const ReferralCommTreeInner = ({ orderTreeData }) => {
	const treeData = useMemo(() => transformDataForTree(orderTreeData), [orderTreeData])
	const treeContainerRef = useRef()

	// Center the tree on mount
	useEffect(() => {
		if (treeContainerRef.current) {
			const { scrollWidth, clientWidth } = treeContainerRef.current
			treeContainerRef.current.scrollLeft = (scrollWidth - clientWidth) / 2
		}
	}, [orderTreeData])

	// Check if all users arrays are empty
	const hasUsers = orderTreeData.some((user) => user.users && user.users.length > 0)

	if (!hasUsers) {
		return (
			<div
				style={{
					textAlign: 'center',
					padding: '20px',
					color: '#888',
					fontFamily: 'Arial, sans-serif',
				}}
			>
				<h3 style={{ fontSize: '24px', marginBottom: '10px' }}>No Users Available</h3>
				<p style={{ fontSize: '16px' }}>There are no users in the referral tree at the moment.</p>
			</div>
		)
	}

	// Custom node rendering function for the TreeNode
	const renderNode = (nodeData) => (
		<div
			style={{
				padding: '15px',
				borderRadius: '12px',
				border: '2px solid #e0e0e0',
				backgroundColor: '#fff',
				boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: '8px',
				minWidth: '180px',
				margin: '0 15px',
				transition: 'all 0.3s ease',
			}}
		>
			<div
				style={{
					width: '60px',
					height: '60px',
					borderRadius: '50%',
					overflow: 'hidden',
					border: '3px solid #fff',
					boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
				}}
			>
				<img
					src={
						nodeData.gender === 'male'
							? 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/kal-visuals-square.jpg'
							: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/team-3.jpg'
					}
					alt='User'
					style={{
						width: '100%',
						height: '100%',
						objectFit: 'cover',
					}}
				/>
			</div>
			<div style={{ textAlign: 'center' }}>
				<h4
					style={{
						fontSize: '16px',
						fontWeight: '600',
						margin: '0',
						color: '#2c3e50',
					}}
				>
					{nodeData.id}
				</h4>
				{nodeData.level !== 0 && (
					<p
						style={{
							fontSize: '14px',
							color: '#7f8c8d',
							margin: '4px 0 0 0',
						}}
					>
						Level: {nodeData.level}
					</p>
				)}
			</div>
		</div>
	)

	// Function to recursively render the tree nodes
	const renderTreeNode = (nodes) => {
		return nodes.map((node) => (
			<TreeNode label={renderNode(node)} key={node.id}>
				{node.children && node.children.length > 0 && renderTreeNode(node.children)}
			</TreeNode>
		))
	}

	return (
		<div
			style={{
				width: '100%',
				position: 'relative',
				fontFamily: 'Arial, sans-serif',
				height: '100vh',
			}}
		>
			{/* <Banners /> */}
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					margin: '0',
				}}
			>
				<div
					style={{
						width: '91.666667%', // col-lg-11 equivalent
						maxWidth: '1400px',
					}}
				>
					<div
						style={{
							backgroundColor: '#fff',
							borderRadius: '8px',
							boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
							padding: '20px',
							marginTop: '-3rem', // mt-n7 equivalent
							minHeight: '100vh',
						}}
					>
						<div style={{ width: '100%', marginTop: '2rem' }}>
							<div
								ref={treeContainerRef}
								style={{
									height: '75vh',
									width: '100%',
									border: '1px solid #eee',
									borderRadius: '12px',
									overflow: 'auto',
									padding: '2rem 1rem',
									backgroundColor: '#f8f9fa',
									'&::-webkit-scrollbar': {
										width: '8px',
										height: '8px',
									},
									'&::-webkit-scrollbar-track': {
										background: '#f1f1f1',
										borderRadius: '4px',
									},
									'&::-webkit-scrollbar-thumb': {
										background: '#95a5a6',
										borderRadius: '4px',
									},
									minHeight: '97vh',
									'&::-webkit-scrollbar-thumb:hover': {
										background: '#7f8c8d',
									},
								}}
							>
								<Tree
									lineWidth={'2px'}
									lineColor={'#95a5a6'}
									lineBorderRadius={'10px'}
									label={
										<div
											style={{
												padding: '12px 24px',

												backgroundColor: '#2c3e50',
												color: '#fff',
												borderRadius: '8px',
												fontSize: '18px',
												fontWeight: '500',
											}}
										>
											Referral Tree
										</div>
									}
								>
									{renderTreeNode(treeData)}
								</Tree>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ReferralCommTreeInner
